import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { UserRole } from '../models/users/subrise-user.model';
import { UserRolesService } from '../services/user-roles.service';
import { loginUrlTree } from '../utils/login-return-url.utils';

/**
 * Grants access only to a genuine Subrise-admin token. Unlike `roleGuard`, partner-tier roles
 * (Strategic/Network/Professional, all `reseller` in the token) do not pass here — use this for
 * routes the side menu already treats as admin-only (see `ADMIN_TREE_DATA` / `FINANCE_MENU_NODE`
 * in `side-menu.component.ts`), where the page itself must not render for other roles.
 */
export const adminGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  const userRolesService = inject(UserRolesService);

  // Read the current auth state rather than the cached snapshot: right after logout the
  // snapshot still holds the signed-out user's roles, which would wave them back through.
  return userRolesService.resolveCurrentRoles().pipe(
    map((roles) => roles.includes(UserRole.Admin) || loginUrlTree(router, state, roles))
  );
};
